import moment from 'moment';
import dateType from 'utils/constants/dateTypes';
import formatMonthPickerValue from './formatMonthPickerValue';

const INITIAL_START_DATE = 1930;
const INITIAL_DOB_DATE = 1975;

export const getPickerOptions = (params, form) => {
  const { type } = params || {};

  // in case of stopTreatment type: start the year from initial_diagnosis_date
  if (type === dateType.stopTreatment) {
    const initialDiagnosisDate = form && formatMonthPickerValue(form.initial_diagnosis_date);
    if (initialDiagnosisDate) {
      return {
        startDate: initialDiagnosisDate,
        endDate: moment().toDate(),
        focusedDate: initialDiagnosisDate,
      };
    }
  } else if (type === dateType.dob) {
    const dob = form && formatMonthPickerValue(form.dob);
    return {
      startDate: moment().year(INITIAL_START_DATE),
      endDate: moment().toDate(),
      focusedDate: dob || moment().year(INITIAL_DOB_DATE),
    };
  }

  return {
    startDate: moment().year(INITIAL_START_DATE),
    endDate: moment().toDate(),
    focusedDate: moment().toDate(),
  };
};
